import React from 'react';
import { Grid } from '@mui/material';
import HelpQs from '../../components/main/HelpQs';

type Props = {}

const HelpPage = (props: Props) => {
    return (
        <>
            <Grid container spacing={2} sx={{ mt: 5, p: 20, '@media (max-width: 1300px)': { p: 0 } }}>
                <HelpQs />
            </Grid>
        </>
    )
}

export default HelpPage